import {
  useCategoryFortuneList,
  useCategoryTelFortuneList,
  useFortuneTellerFortuneList,
  useFortuneTellerTelFortuneList,
} from "repositories/hooks";
import { Fortune, TelFortune, fortuneTellerTelFortuneListSortOrder } from "shared/types";

const getCategoryFortuneListParams = {
  page: 1,
  limit: 5,
  orderBy: "popular" as const,
};

const getFortuneTellerFortuneListParams = {
  orderBy: fortuneTellerTelFortuneListSortOrder.costPerMinute,
}

interface UseFetchDataReturn {
  fortuneTellerMenus: (Fortune | TelFortune)[];
  categoryMenus: (Fortune | TelFortune)[];
}

export const useFetchData = (
  menu: Fortune | TelFortune
): UseFetchDataReturn => {
  const { fortunes: fortuneTellerFortunes } = useFortuneTellerFortuneList(
    menu?.fortuneTeller?.id
  );
  const { telFortunes: fortuneTellerTelFortunes } =
    useFortuneTellerTelFortuneList(menu?.fortuneTeller?.id, getFortuneTellerFortuneListParams);
  const { fortunes: categoryFortunes } = useCategoryFortuneList(
    menu?.category?.alias,
    getCategoryFortuneListParams
  );
  const { telFortunes: categoryTelFortunes } = useCategoryTelFortuneList(
    menu?.category?.alias,
    getCategoryFortuneListParams
  );

  const fortuneTellerMenus = [
    ...fortuneTellerFortunes,
    ...fortuneTellerTelFortunes,
  ];
  const categoryMenus = [...categoryFortunes, ...categoryTelFortunes];

  return {
    fortuneTellerMenus,
    categoryMenus,
  };
};
